import { getGlobalConfigKey } from "@src/globalConfig"
import { createContext, useContext } from "react"

const CgFeatureFlagContext = createContext<{
  getCgFeatureFlag: (<T>(flag: string, defaultValue: T) => T) | undefined
} | null>(null)

export const CgFeatureFlagContextProvider = CgFeatureFlagContext.Provider

type CgFeatureFlag =
  | "rollout-show-human-risk-for-all"
  | "rollout-human-risk-action-log-updates"

/*
 * Use to get feature flags from Mimecast LaunchDarkly only when embedded in CG.
 * Make sure to check that isCG is true before relying on the value returned.
 */
export function useCgFeatureFlag<T = boolean>(
  flag: CgFeatureFlag,
  defaultValue: T,
): { isCg: true; value: T } | { isCg: false; value: null } {
  const context = useContext(CgFeatureFlagContext)
  if (getGlobalConfigKey() !== "mimecast_cg") {
    return {
      isCg: false,
      value: null,
    }
  }
  if (!context) {
    throw new Error("Must be used inside CgFeatureFlagContextProvider")
  }
  return {
    isCg: true,
    value: context.getCgFeatureFlag<T>?.(flag, defaultValue) ?? defaultValue,
  }
}
